import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/services/user.service';
import { AppService } from '../../app.service';
import { JobPositionsForms, SafetyPositionsVM, UserOverviewModel } from '../../entities';
import { NotificationsService } from 'angular2-notifications';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-job-positions',
  templateUrl: './job-positions.component.html',
  
  styleUrls: ['./job-positions.component.scss']
})
export class JobPositionsComponent implements OnInit {

  jobPositionList:SafetyPositionsVM[]=[]
  userList:UserOverviewModel[]=[]
  SelectedUserList:UserOverviewModel[]=[]

  formList:JobPositionsForms[]=[]
  SelectedFormList:JobPositionsForms[]=[]
  isAllUsersSelected:boolean
  
  positionID:number
  positionName:string
  createdBy:string
  positionDetails:string
  isActive:boolean=false  
  btnDisabledAdd:boolean=false
  btnDisabledUpdate:boolean=true
  btnDisabledDelete:boolean=true
  displayedColumnsUser: string[] = ['FullName', 'USI', 'select'];
  displayedColumnsForm: string[] = ['FormName', 'FormCategory','isDigital', 'select'];
  
dataSourceUser = new MatTableDataSource();
dataSourceForm = new MatTableDataSource();
selectionUser = new SelectionModel(true, []);
selectionForm = new SelectionModel(true, []);
  constructor(    private _appService: AppService,
    private _userService: UserService,  
    private _notify: NotificationsService,) { }

 
  ngOnInit() {
    this._appService.setPageTitle('Job Positions');
    this.getJobPositions();
    
  }


  getJobPositions(){
    this._userService.getSafetyJobPositins().subscribe(res=>{
     this.jobPositionList=res
    })
  }
  ChangeCheckbox(event){
    console.log(event.checked)
    this.isActive=event.checked
}

onSelectPosition(event){
  
  var filterval= this.jobPositionList.filter(f=>f.Id==event.value)
  console.log(filterval)
  this.positionID=filterval[0].Id
  this.positionName=filterval[0].positionName
  this.positionDetails=filterval[0].Description
  this.createdBy=filterval[0].updatedUserName
  this.isActive=filterval[0].Active

  this.btnDisabledAdd=true
  this.btnDisabledUpdate=false
  this.btnDisabledDelete=false
  //get all user positions
 this._userService.GetAllUsersForJobPosition(this.positionID).subscribe(res=>{
  this.userList=res
  this.dataSourceUser.data = this.userList;
  
 })

 //get all form positions
 this._userService.GetAllFormsJobPosition(this.positionID).subscribe(res=>{
 this.formList=res
   this.dataSourceForm.data = this.formList;
 })

}
  addNewPosition(){
    let model = new SafetyPositionsVM();
    model.positionName=this.positionName
    model.Description=this.positionDetails
    model.Active=this.isActive
   
    this._userService.AddNewJobPosition(model).subscribe(res=>{
      if(res==true){
        this.getJobPositions();
        this._notify.success("Sucessfully Added")
        
      }
      else{
        this._notify.error("An Error Occured")
      }
    })
  }
  updatePosition(){
    let model = new SafetyPositionsVM();
    model.Id=this.positionID
    model.positionName=this.positionName
    model.Description=this.positionDetails
    model.Active=this.isActive
   
    this._userService.UpdateJobPosition(model).subscribe(res=>{
      if(res==true){
        this.getJobPositions();
        this._notify.success("Sucessfully Updated")
      }
      else{
        this._notify.error("An Error Occured")
      }
    })
  }
 
  deletePosition(){
    
    let model = new SafetyPositionsVM();
    model.Id=this.positionID  
   
    this._userService.DeleteJobPosition(model).subscribe(res=>{
      if(res==true){
        this.getJobPositions();
        this._notify.success("Sucessfully Deleted")
      }
      else{
        this._notify.error("An Error Occured")
      }
    })
  }

  GetAllUsersForJobPosition(){
    this._userService.GetAllUsersForJobPosition(this.positionID).subscribe(res=>{
     this.userList=res
     this.dataSourceUser.data = this.userList;
    })
  }

  GetAllFormsJobPosition(){
    this._userService.GetAllFormsJobPosition(this.positionID).subscribe(res=>{
      this.formList=res
        this.dataSourceForm.data = this.formList;
      })
  }






  isAllSelectedUser() {  
    const numSelected = this.selectionUser.selected.length;
    const numRows = this.dataSourceUser.data.length;
    return numSelected === numRows;  
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggleUser() {
    console.log("isAllSelectedUser",this.isAllSelectedUser())
    
    if(this.isAllSelectedUser()==false){
      for(let i=0;i<this.userList.length; i++){
        this.userList[i].select=true
      }     
      }
     
      if(this.isAllSelectedUser()==true){
        for(let i=0;i<this.userList.length; i++){
          this.userList[i].select=false
        }
        
        }

        if (this.isSomeSelectedUser()) {
          this.selectionUser.clear();
        } else {
          this.isAllSelectedUser() ?
            this.selectionUser.clear() :
            this.dataSourceUser.data.forEach(row => this.selectionUser.select(row));
        }
    // this.isAllSelectedUser() ?
    //     this.selectionUser.clear() :
    //     this.dataSourceUser.data.forEach(row => this.selectionUser.select(row));
  
  }

  isSomeSelectedUser() {
    return this.selectionUser.selected.length > 0;
  }

  isAllSelectedForm() {
    const numSelected = this.selectionForm.selected.length;
    const numRows = this.dataSourceForm.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggleForm() {
    if(this.isAllSelectedForm()==false){
      for(let i=0;i<this.formList.length; i++){
        this.formList[i].select=true
      }
      }
      if(this.isAllSelectedForm()==true){
        for(let i=0;i<this.formList.length; i++){
          this.formList[i].select=false
        }
        }
        if (this.isSomeSelectedForm()) {
          this.selectionForm.clear();
        } else {
          this.isAllSelectedForm() ?
            this.selectionForm.clear() :
            this.dataSourceForm.data.forEach(row => this.selectionForm.select(row));
        }
  }

  
  isSomeSelectedForm() {
    return this.selectionForm.selected.length > 0;
  }
  resetFields(){
    this.positionID=0;
    this.positionName="";
    this.createdBy="";
    this.positionDetails=""
    this.isActive=false  
    this.btnDisabledAdd=false
    this.btnDisabledUpdate=true
    this.btnDisabledDelete=true
    this.dataSourceUser.data=[];
    this.dataSourceForm.data=[];
  
  }

UpdateSafetyUserPositions(){
  this.SelectedUserList=this.userList.filter(f=>f.select==true)
    this._userService.UpdateSafetyUSerPosition(this.SelectedUserList, this.positionID).subscribe(res=>{
      if(res==true){        
        this._notify.success("Sucessfully Updated")
        this.GetAllUsersForJobPosition();
      }
      else{
        this._notify.error("An Error Occured")
      }
    })
  
}

UpdateSafetFormPosition(){
 
  this.SelectedFormList=this.formList.filter(f=>f.select==true) 
  this._userService.UpdateSafetFormPosition(this.SelectedFormList, this.positionID).subscribe(res=>{
    if(res==true){        
      this._notify.success("Sucessfully Updated")
      this.GetAllFormsJobPosition()
    }
    else{
      this._notify.error("An Error Occured")
    }
  })
}
}
